import I18n from "../../I18n";
import { datetime, date, formatFileSize } from "../../utils";
import { stringifyFilter } from "colbi_web_ui/lib/utils";
import { finalStatus, generateFindingColumn } from "../../utils/dataFileEnum";
import { getFileStatus, getMergeStatus, getProcessingStage } from "../../utils/dataFileStage";

const mapCard = (json) => {
    const {
        id,
        name,
        status,
        uploadedAt,
        submittedBy,
        fiscalYear,
        type,
        subType,
        profileId,
        statusCode,
        fileSizeDecompress,
        startDate,
        endDate,
        internalStatus,
    } = json;

    const { family, mergeStatusMessage } = getMergeStatus(internalStatus);

    const { color, statusFamily } = getFileStatus(status);

    const hasFindings = generateFindingColumn(statusCode, status, I18n, fiscalYear, id);

    return [
        [
            {
                labels: ["id"],
                value: id,
                type: "string",
                align: "align-left",
                basis: "10%",
            },
        ],
        [{ labels: ["File"], value: name, type: "string", align: "align-left" }],
        [
            {
                labels: ["fiscalYear"],
                value: fiscalYear,
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["uploaded"],
                value: datetime(uploadedAt),
                type: "datetime",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["fileSizeDecompress"],
                value: formatFileSize(fileSizeDecompress),
                type: "number",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["type"],
                value: profileId
                    ? {
                          id: profileId,
                          name: I18n.translate`${type}`,
                          customParam: {},
                          to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/${profileId}/column_mapping/${profileId}?tab=mapping`,
                      }
                    : { name: I18n.translate`${type}` },
                type: "repoHasFindings",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["subtype"],
                value: subType,
                type: "string",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["start"],
                value: date(startDate),
                type: "datetime",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["end"],
                value: date(endDate),
                type: "datetime",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["user"],
                value: submittedBy,
                type: "string",
                align: "left",
                mobileHidden: true,
            },
        ],

        [
            {
                value: {
                    severity: 4,
                    value: I18n.translate`${status}`,
                    label: I18n.translate`${status}`,
                    family: statusFamily || "text",
                    color: color,
                },
            },
        ],
        [hasFindings],
        [
            {
                labels: ["status"],
                value: `${getProcessingStage(status)}/9`,
                type: "string",
                align: "center",
                style: "bold",
            },
        ],
        [
            {
                value: {
                    severity: 4,
                    value: I18n.translate`${mergeStatusMessage}`,
                    label: I18n.translate`${mergeStatusMessage}`,
                    family: family || "text",
                    color: "main",
                },
            },
        ],
    ];
};

const mapper = (json, card) => {
    const linkToUse =
        json.status === "imported"
            ? `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/folders`
            : `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/invalid_files`;
    const currentViewMode =
        typeof window !== "undefined"
            ? new URLSearchParams(window.location.search).get("viewMode")
            : null;
    const filter = stringifyFilter([{ column: "ID", filters: [{ value: `${json.id}` }] }]);
    const viewModeQuery = currentViewMode ? `&viewMode=${encodeURIComponent(currentViewMode)}` : "";
    return {
        ...json,
        id: json.id,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: finalStatus.includes(json.status)
            ? {
                  to: `${linkToUse}?filter=${filter}${viewModeQuery}`,
              }
            : null,
    };
};

const header = [
    { label: ["Id"], align: "left", basis: "10%" },
    { label: ["File"], align: "left", columnName: "name", sortable: true },
    {
        label: ["Fiscal Year"],
        align: "center",
        columnName: "fiscal_year",
        sortable: true,
    },
    {
        label: ["Uploaded at"],
        align: "center",
        mobileHidden: true,
        columnName: "uploaded_at",
        sortable: true,
    },
    {
        label: ["File Size"],
        align: "center",
        mobileHidden: true,
        columnName: "file_size_decompress",
        sortable: true,
    },
    {
        label: ["Type"],
        align: "left",
        mobileHidden: true,
        columnName: "type",
        sortable: true,
        type: "repoHasFindings",
    },
    {
        label: ["Sub Type"],
        align: "left",
        mobileHidden: true,
        columnName: "sub_type",
        sortable: true,
    },
    { label: ["Start Date"], align: "center", mobileHidden: true },
    { label: ["End Date"], align: "center", mobileHidden: true },
    { label: ["Uploaded by"], align: "left", mobileHidden: true },
    { label: ["Status"], align: "left", columnName: "status", sortable: true, type: "status" },
    { label: ["Findings"], align: "center", type: "repoHasFindings" },
    { label: ["Stage"], align: "center" },
    {
        label: ["Merge Status"],
        align: "left",
        mobileHidden: true,
        columnName: "internal_status",
        sortable: true,
        type: "status",
    },
];

const activityMapper = {
    map: mapper,
    header,
};
export default activityMapper;
